import { Banner as Banner$1, BannerSecondaryAction, BannerPrimaryAction, BannerDescription, BannerTitle } from './Banner.js';

const Banner = Object.assign(Banner$1, {
  Title: BannerTitle,
  Description: BannerDescription,
  PrimaryAction: BannerPrimaryAction,
  SecondaryAction: BannerSecondaryAction
});

export { Banner };
